export default __webpack_public_path__ + "assets/21b2dd0221a14da1017be398b1c6a736.svg";